import MuiList from "./overrides/MuiList";
import MuiListItem from "./overrides/MuiListItem";
import MuiButton from "./overrides/MuiButton";

const overrides = {
  MuiList,
  MuiListItem,
  MuiButton,
};

export default overrides;
